import React from 'react';
import { CarouselWidget } from 'components/widgets/carousel-widget';
import './index.scss';
import { CarouselItem } from './structs';

interface ConditionCarouselWidgetProps {
    items: CarouselItem[];
    stretch: boolean
}

const ConditionCarouselWidget = (props: ConditionCarouselWidgetProps) => {
    const items = props.items ?? [];
    if (items.length <= 0) {
        return (<></>)
    }
    const slidesFactory = () => {
        return props.items?.map((item, i) => (
            <swiper-slide class="condition-carousel-slide">
                <div className='condition-carousel-card'>
                    <a href={item.link}>
                        <img alt={`${item.title}`} src={item.imageUrl} />
                        <pui-text textsize='large'
                            textalign='center'
                            fontweight='bold' input={item.title}></pui-text>
                    </a>
                </div>
            </swiper-slide>
        ))
    }
    return (<CarouselWidget stretch={props.stretch} slidesFactory={slidesFactory} />)
}


export default ConditionCarouselWidget;
